import Typography from '@repo/ui/typography'
import { useEffect } from 'react'

import withTheme from '../../components/hoc/with-theme'
import AuthLayout from '../../components/layouts/auth-layout'
import { SsoLoginForm } from '../../components/pages/login/sso-login-form'

export const PcrLoginPage = () => {
  useEffect(() => {
    document.querySelector('html')?.setAttribute('data-theme', 'admin')
  }, [])

  return (
    <AuthLayout text="Bienvenue à nouveau!">
      <Typography variant="h1" className="mb-6">
        Se connecter
      </Typography>
      <SsoLoginForm />
    </AuthLayout>
  )
}

export default withTheme(PcrLoginPage, 'admin')
